module.exports = __webpack_public_path__ + "static/media/7.742e1e31.jpg";